import { Skeleton } from "@/components/ui/skeleton"

/**
 * Skeleton loader for the menu item detail dialog
 */
export function MenuItemDetailSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      {/* Image skeleton */}
      <div className="w-full aspect-[16/7] lg:aspect-square overflow-hidden">
        <Skeleton className="w-full h-full" />
      </div>

      <div className="flex flex-col">
        <div className="w-full h-[400px]">
          <div className="flex flex-col gap-3 xl:pl-2 px-5">
            {/* Title and price skeleton */}
            <div className="flex justify-between pb-2">
              <Skeleton className="h-7 w-3/5" />
              <Skeleton className="h-6 w-20" />
            </div>

            {/* Order count skeleton */}
            <div className="flex items-center gap-3">
              <Skeleton className="h-4 w-24" />
            </div>

            {/* Description skeleton */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-4/5" />
            </div>

            {/* Textarea skeleton */}
            <Skeleton className="h-24 w-full mt-2" />

            {/* Customize items skeleton */}
            <div className="mt-5 flex flex-col gap-4">
              <div className="border-b pb-4">
                <Skeleton className="h-6 w-40 mb-2" />
                <div className="space-y-3">
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-10 w-full" />
                </div>
              </div>
              <div className="border-b pb-4">
                <Skeleton className="h-6 w-40 mb-2" />
                <div className="space-y-3">
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-10 w-full" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Button skeleton */}
        <div className="flex gap-3 mt-7 pr-5 w-full border-t border-gray-200 pt-3">
          <Skeleton className="h-11 w-24" />
          <Skeleton className="h-11 flex-1" />
        </div>
      </div>
    </div>
  )
}
